import useIntlStore from "@/stores/useIntlStore";
import enUS from "../../../../locale/enums/en-US.json";
import zhCN from "../../../../locale/enums/zh-CN.json";
import jaJP from "../../../../locale/enums/ja-JP.json";

const transEnumsI18n = (groupCode: string, target: string) => {
  const { locale } = useIntlStore.getState();

  const key = `${groupCode}.${target}`;

  switch (locale) {
    case "zh-CN":
      return zhCN[key] || target;
    case "en-US":
      return enUS[key] || target;
    case "ja-JP":
      return jaJP[key] || target;
    default:
      return zhCN[key] || target;
  }
};

export default transEnumsI18n;
